<template>
  <v-dialog
    v-if="component == 'dialog'"
    v-model="show"
  >
    <v-card color="secondary">
      <v-card-actions>
        <v-icon
          :color="type"
          class="mr-4"
          large
          v-text="icons[type]"
        />
        <div class="my-4">
          <div v-for="str in messages" v-html="str" />
        </div>
        <v-spacer />
        <v-btn
          color="primary"
          icon
          @click="show = false"
        >
          <v-icon small v-text="icons.close" />
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-snackbar
    v-else
    v-model="show"
    :color="type"
    timeout="12000"
  >
    <div v-for="str in messages" v-html="str" />
    <template #action="{ attrs }">
      <v-btn
        v-bind="attrs"
        icon
        @click.stop.prevent="handleClose"
      >
        <v-icon small v-text="icons.close" />
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
  import { mapState } from 'vuex'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      UsesIcons,
    ],

    computed: {
      show: {
        get () {
          return this.$store.state.alert.show
        },
        set (v) {
          if (! v) {
            this.$store.dispatch('alert/hide')
          }
        }
      },
      ...mapState('alert', [
        'component',
        'type',
        'message',
      ]),
      messages () {
        return Array.isArray(this.message) ? this.message : Array.of(this.message)
      },
    },

    methods: {
      handleClose (event) {
        if (event) {
          event.stopPropagation()
          event.preventDefault()
        }
        this.$root.$emit('snackbar-closing')
        this.show = false
        setTimeout(() => {
          this.$root.$emit('snackbar-closed')
        }, 100)
      },
    },
  }
</script>
